import { Atom } from '@phosphor-icons/react';
import { SettingKeys } from 'src/types/settings';
import { SettingsSwitchItem } from '../SettingsSwitchItem';
import styles from './DeepResearchSection.module.scss';

export const DeepResearchSection = () => {
  return (
    <div className={styles.root}>
      <p className={styles.title}>Task notifications</p>
      <p className={styles.caption}>
        Send email once Deep Research results are available
      </p>

      <div className={styles.options}>
        <SettingsSwitchItem
          value={SettingKeys.DEEP_RESEARCH_EMAIL}
          label="Email"
          icon={Atom}
          settingKey={SettingKeys.DEEP_RESEARCH_EMAIL}
        />
      </div>
    </div>
  );
};
